import 'whatwg-fetch';
import config from '../../config/config';

const { API_DISCOUNT_URL } = config;


export const promoApi = {
    apply: async (cartItems, code) => {
        const fetchOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                cart: cartItems.map(item => ({
                    id: item.id,
                    price: String(item.price),
                    quantity: item.quantity,
                })),
                code: code,
            }),
        };

        const response = await fetch(
            API_DISCOUNT_URL,
            fetchOptions
        );

        const result = await response.json();

        if (result.code === 200) {
            return {
                success: true,
                coupon: result.data.coupon,
                discount: result.data.discount,
            };
        } else {
            return {
                success: false,
                message: result.message || 'Промокод недействителен',
            };
        }
    },
};